import { Component } from '@angular/core';

@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  standalone: false,
})
export class OfflineComponent {}
